/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { chatSessionsCreate } from "../funcs/chatSessionsCreate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { CreateResponseBody } from "../models/components/createresponsebody.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateChatSessionRequest,
  CreateChatSessionSecurity,
} from "../models/operations/createchatsession.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type ChatSessionsCreateMutationVariables = {
  request: CreateChatSessionRequest;
  security?: CreateChatSessionSecurity | undefined;
  options?: RequestOptions;
};

export type ChatSessionsCreateMutationData = CreateResponseBody;

export type ChatSessionsCreateMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * create chatSessions
 *
 * @remarks
 * Creates a new chat session token
 */
export function useChatSessionsCreateMutation(
  options?: MutationHookOptions<
    ChatSessionsCreateMutationData,
    ChatSessionsCreateMutationError,
    ChatSessionsCreateMutationVariables
  >,
): UseMutationResult<
  ChatSessionsCreateMutationData,
  ChatSessionsCreateMutationError,
  ChatSessionsCreateMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildChatSessionsCreateMutation(client, options),
    ...options,
  });
}

export function mutationKeyChatSessionsCreate(): MutationKey {
  return ["@gram/client", "chatSessions", "create"];
}

export function buildChatSessionsCreateMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: ChatSessionsCreateMutationVariables,
  ) => Promise<ChatSessionsCreateMutationData>;
} {
  return {
    mutationKey: mutationKeyChatSessionsCreate(),
    mutationFn: function chatSessionsCreateMutationFn({
      request,
      security,
      options,
    }): Promise<ChatSessionsCreateMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(chatSessionsCreate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
